// extracted by mini-css-extract-plugin
module.exports = {"btnPlay":"btnPlay_btnPlay__MVf4V","btnPlayHover":"btnPlay_btnPlayHover__7ChpT"};